import { Typography } from 'antd';

export interface DebtTextProps {
  balance: string;
  status: 'YOU_OWE' | 'STORE_OWES' | 'EVEN';
}

/** §7/§9: баланс текстом по знаку — «Вы должны N» / «Магазин должен вам N» / «Баланс: 0». */
export function DebtText({ balance, status }: DebtTextProps) {
  if (status === 'EVEN') return <Typography.Text>Баланс: 0</Typography.Text>;
  const label = status === 'YOU_OWE' ? 'Вы должны' : 'Магазин должен вам';
  return (
    <Typography.Text style={{ color: status === 'YOU_OWE' ? '#cf1322' : '#389e0d' }} strong>
      {label}: {balance}
    </Typography.Text>
  );
}
